import React, { createContext, useState, useEffect, useContext } from "react"
import { oauthLogin, checkUser, saveLog, listBuildingLogin, removeBuildingLogin } from '../Network/Authentication'
import { RoleContext } from '../Role/RoleContext'
import { ModalContext } from '../Library/ModalContext'
import { NotifyContext } from '../Library/Notify'
import { axiosClient } from '../Network/AxiosClient'
import { oauthPrefix } from '../Network/Config'
import GettingStarted from "../Library/GettingStarted"
import { LanguageContext } from "../Language/LanguageContext"
import { setUserId } from "firebase/analytics"

const AuthContext = createContext()
const isAuthStatus = localStorage.getItem("is_auth") || false

function useProvideAuth(){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.error
    const notify = useContext(NotifyContext);
    const role = useContext(RoleContext)
    const modal = useContext(ModalContext)
    const [isAuth, setAuth] = useState(isAuthStatus);
    const [currentUser, setCurrentUser] = useState(null);
    const [username, SetUsername] = useState(null)
    const [] = useState(null);
    const accessToken = localStorage.getItem("access_token");
    const isLoginFinish = localStorage.getItem("is_login_finish")

    const obtainUser = () => {
        return new Promise((resolve, reject)=>{
            checkUser(
                (userData)=>{
                    let user = userData.user
                    SetUsername(userData.user.username)
                    setCurrentUser(userData)
                    localStorage.setItem("building_id", userData.building.id)
                    localStorage.setItem("usernames", userData.user.username)
                    //console.log(userData.company.name)
                    //console.log(userData.roles)
                    role.setAccessControls(userData.roles)
                    if(userData.roles.length > 0){
                        let firstRole = userData.roles[0]
                        localStorage.setItem("role_level", firstRole.level)
                    }else{
                        localStorage.setItem("role_level", 99)
                    }
    
                    // First login without accept term
                    if(!user.acceptTerm){
                        modal.setDisableBackDrop(true)
                        modal.setComponent(
                           <GettingStarted onFinishSetup={()=>modal.setShow(false)}/>
                        )
                        modal.setShowHeader(false)
                        modal.setShow(true)
                        modal.setDark(false)
                    }
    
                    localStorage.setItem("name", user.firstName + " " + user.lastName)
                    localStorage.setItem("email", user.email)
                    localStorage.setItem("profile_img", user.profileImagePath)
                    localStorage.setItem("is_super_admin", user.isSuperAdmin)
                    if(userData.company !== null){
                        localStorage.setItem("company_id", userData.company.id)
                        localStorage.setItem("company_name", userData.company.name)
                        localStorage.setItem("officePhone", userData.company.officePhone)
                    }
                    if(userData.building !== null){
                        let building = userData.building
                        localStorage.setItem("building_name", building.buildingName)
                        localStorage.setItem("limit_user", building.packages.limitUser)
                        localStorage.setItem("limit_tenants", building.packages.limitTenants)
                    }
    
                    listBuildingLogin()
                    .then((buildingData)=>{
                        resolve({
                            userData: userData,
                            buildings: buildingData
                        })
                    })
                    .catch((error) => { 
                        console.log(error)
                        reject(error)
                    })
                    
                },
                (error)=>{
                    deleteParams()
                    setAuth(false)
                    if(error?.response?.status === 401){
                        notify.showNotify(lang.login_expired, lang.user_expired, 1)
                    }else{
                        notify.showNotify(lang.something_wrong, error.message, 1)
                    }

                    reject()
                }
                
            )
        })
        
    }
    
    useEffect(()=>{
        if(accessToken !== null && isLoginFinish === "true"){
            obtainUser()
        }else{
            localStorage.removeItem("is_login_finish")
            setAuth(false)
        }
    }, [accessToken])


    const signin = (username, password, callback, errorCallback) =>{
        oauthLogin(username, password,
            (data)=>{
                axiosClient.interceptors.request.use(
                    config=>{
                        config.headers["Authorization"] = oauthPrefix + data.access_token
                        return config
                    },
                    error=>{
                        Promise.reject(error)
                    }
                )
                obtainUser()
                .then((res)=>{
                    saveLog(()=>{}, ()=>{})
                    const resData = {
                        isAuth: true,
                        buildings: res.buildings,
                        user: res.userData
                    }
                    callback(resData)
                })
                .catch((error)=>{
                    errorCallback(error)
                })
                
            },
            (error)=>{
                console.log(error);
                errorCallback(error)
            })
    }

    const signout = (callback) =>{
        setAuth(false)
        deleteParams()
        callback()
        
    }

    const deleteParams = () =>{
        localStorage.removeItem("name")
        localStorage.removeItem("email")
        localStorage.removeItem("profile_img")
        localStorage.removeItem("company_id")
        localStorage.removeItem("access_token")
        localStorage.removeItem("is_auth")
        localStorage.removeItem("task_count")
        localStorage.removeItem("is_super_admin")
        localStorage.removeItem("building_name")
        localStorage.removeItem("limit_user")
        localStorage.removeItem("limit_tenants")
        localStorage.removeItem("building_id")
        Object.keys(localStorage).forEach((item)=>{
            if(item.startsWith("_MENU_") || item.startsWith("NEWS_")){
                localStorage.removeItem(item)
            }
        })
    }

    return { isAuth, signin, signout, obtainUser, currentUser, username, setAuth }
}

function AuthProvider(props){
    const auth = useProvideAuth()
    return(
        <AuthContext.Provider value={auth}>
            {props.children}
        </AuthContext.Provider>
    )
}

export { AuthProvider, AuthContext }